import { Fragment, useState } from 'react';
import { Menu, ThemeProvider, Box, styled } from '@mui/material';
import useSettings from 'app/hooks/useSettings';

const MenuButton = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  alignSelf: 'stretch',
  minHeight: '100%',
  position: 'relative',
  zIndex: 1,
  border: 0,
  padding: 0,
  margin: 0,
  background: 'transparent',
  cursor: 'pointer',
  color: theme.palette.text.primary,
  '&:focus-visible': {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: 2
  }
}));

const MatxMenu = (props) => {
  const { settings } = useSettings();
  const [anchorEl, setAnchorEl] = useState(null);

  let { shouldCloseOnItemClick = true, horizontalPosition = 'left' } = props;

  const handleClose = () => setAnchorEl(null);
  const handleClick = (event) => setAnchorEl(event.currentTarget);

  return (
    <Fragment>
      <MenuButton
        component="button"
        type="button"
        aria-haspopup="menu"
        aria-expanded={Boolean(anchorEl)}
        onClick={handleClick}
      >
        {props.menuButton}
      </MenuButton>
      <ThemeProvider theme={settings.themes[settings.activeTheme]}>
        <Menu
          elevation={8}
          open={!!anchorEl}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: horizontalPosition }}
          transformOrigin={{ vertical: 'top', horizontal: horizontalPosition }}
          MenuListProps={{
            'aria-label': 'User menu',
            onClick: shouldCloseOnItemClick ? handleClose : undefined
          }}
        >
          {props.children}
        </Menu>
      </ThemeProvider>
    </Fragment>
  );
};

export default MatxMenu;
